<template>
  <div :class="[ 'popup-inner', popup.class ]">
    <div>
      <h1
        v-if="popup.heading"
        v-html="$getString(popup.heading)"
      ></h1>

      <template
        v-for="(item, index) in popup.items"
      >
        <PopupList v-if="item.type === 'list'" :key="index" :items="item.value" :classes="item.class || ''" />
        <PopupImageList v-if="item.type === 'image-list'" :key="index" :items="item.value" :classes="item.class || ''" />
        <PopupButtonList v-if="item.type === 'button-list'" :key="index" :items="item.value" :classes="item.class || ''" @action="onPressed" />
        <PopupText v-if="item.type === 'text'" :key="index" :lines="item.value" :classes="item.class || ''" />
        <PopupTextColumns v-if="item.type === 'text-columns'" :key="index" :columns="item.value" :classes="item.class || ''" />
        <img v-if="item.type === 'image'" :key="index" :src="item.value" :alt="item.alt || '...'" :width="item.width || '100%'" :class="item.class || ''" />
      </template>
    </div>

    <div class="popup-buttons">
      <DefaultButton
        v-for="(button, index) in popup.buttons"
        :key="index"
        :label="button.label"
        labelClass="text-uppercase"
        type="popup"
        @pressed="onPressed(button)"
      />
    </div>

    <slot></slot>
  </div>
</template>

<script>
import DefaultButton from '../partials/DefaultButton'
import PopupList from '../partials/PopupList'
import PopupButtonList from '../partials/PopupButtonList'
import PopupImageList from '../partials/PopupImageList'
import PopupText from '../partials/PopupText'
import PopupTextColumns from '../partials/PopupTextColumns'

export default {
  name: 'PopupDefault',
  components: {
    DefaultButton,
    PopupList,
    PopupText,
    PopupTextColumns,
    PopupButtonList,
    PopupImageList,
  },
  props: {
    popup: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onPressed(event) {
      this.$emit('action', event);
    }
  },
}
</script>
  